import React, { useEffect, useState } from 'react'
import './contractors-catalog.view.css'

import { ButtonAddHLPure, DialogContractor, DialogSystemGLPure, DropDownBtnHLPure, FilterHLPure, GridHLFigma, PromotionalFooterPure, SearchBarHLPure, SimpleLoading, SubtitlePageHLPure, GridSelectionHLPure, ButtonHLPure } from '../../pures'
import ContractorsCatalogConfigurationView from './contractors-catalog-configuration.view'
import { Container, Grid, useMediaQuery } from '@material-ui/core'
import { profileIconDefault } from '../../../assets/logos/icons'
import { ContractRequestService } from '../../../services'
import { useTranslation } from 'react-i18next'


const statusContractor = [
    {
        id: 0,
        name: 'Todos'
    },
    {
        id: true,
        name: 'Activos'
    },
    {
        id: false,
        name: 'Inactivos'
    },
]


const ContractorsCatalogView = (props) => {

    let {
        isLoadingView,
        token,
        user,
        toggleErrorRequesting,
        toggleLoadingRequesting,
        toggleCompletedRequesting,
        toggleLoadingScreen,
        showCompletedRequesting,
        showErrorRequesting,
        showLoadingRequesting,
        messageError,
        paramsId,
        titleBtnAdd,
        placeHolderSearch,
        titleColumnName,
        contractors,
        companies,
        selfEmail,
        getConractorsForService,
        setLogoFile,
        contractorsTypes,
        companiesToClassified
    } = props

    const { t } = useTranslation()

    const url = process.env.REACT_APP_MIFIRMA_API
    const contractRequest = new ContractRequestService(url)

    const today = new Date()
    let limitMaxDate = new Date()
    limitMaxDate.setDate(limitMaxDate.getDate() + 61)

    const headerColumnOne = (props) => {
        return <span className='contractorsCatalogView-header-cell-one'>{props.title}</span>
    }

    const headerColumnTwo = (props) => {
        return <span className='contractorsCatalogView-header-cell-two'>{props.title}</span>
    }

    const headerColumnThree = (props) => {
        return <span className='contractorsCatalogView-header-cell-three'>{props.title}</span>
    }

    const cellColumnOne = (props) => {
        return (
            <td className='contractorsCatalogView-cell-one'>
                <div className='contractorsCatalogView-containerAvatar'>
                    <div className='contractorsCatalogView-imageAvatar'>
                        <img
                            alt='profile-img'
                            src={props.dataItem.logo || profileIconDefault}
                            className='contractorsCatalogView-avatar'
                        />
                    </div>
                </div>
            </td>
        )
    }

    const cellColumnTwo = (props) => {
        return (
            <td className='contractorsCatalogView-cell-two'>
                <div className='contractorsCatalogView-labels-column1'>
                    <p className='contractorsCatalogView-title-column1'>
                        {props.dataItem.name}
                    </p>
                    <p className='contractorsCatalogView-subtitle-column1'>
                        {`${t('contractorsCatalogView.modifiedby')} ${props.dataItem.date}`}
                    </p>
                </div>
            </td>
        )
    }

    const cellColumnThree = (props) => {
        return (
            <td className='contractorsCatalogView-cell-three'>
                <div className='contractorsCatalogView-imageAvatar'>
                    <p className={(props.dataItem.status) ? 'contractorsCatalogView-grid' : 'contractorsCatalogView-gridInactive'}>
                        {(props.dataItem.status) ? 'Activo' : 'Inactivo'}
                    </p>
                </div>
            </td>
        )
    }

    const [headerTitleinDetail, setHeaderTitleinDetail] = useState({
        clicked: false,
        name: '',
    })
    const [showDetails, setShowDetails] = useState(false)
    const [nameComponentUser, setNameComponentUser] = useState('')
    const [contratorsStatusFilter, setContratorsStatusFilter] = useState(statusContractor)
    const [companiesFilter, setCompaniesFilter] = useState([])
    const [titleHeader, setTitleHeader] = useState(t('contractorsCatalogView-contractor-title'))
    const [stateNameComponentUser, setStateNameComponentUser] = useState('')
    const [dataContractors, setDataContractors] = useState([])
    const [contractorsStatusSelected, setContractorsStatusSelected] = useState(0)
    const [contractorGridSelected, setContractorGridSelected] = useState({})
    const [contractorNameSearch, setContractorNameSearch] = useState('')
    const [companyFilerSelected, setCompanyFilterSelected] = useState(0)
    const [imageTitle, setImagetitle] = useState(null)
    const [showDialogIcon, setShowDialogIcon] = useState(false)
    const [uploadImage, setuploadImage] = useState(null)
    const [showCreateContractor, setShowCreateContractor] = useState(false)
    const [newContractorName, setNewContractorName] = useState('')
    const [newContractorEmail, setNewContractorEmail] = useState('')
    const [itselfRegister, setItselfRegister] = useState(false)
    const [newContractLimitDate, setNewContractLimitDate] = useState(today)
    const [toggleErrorInDate, setToggleErrorInDate] = useState(false)
    const [newContractorNotes, setNewContractorNotes] = useState('')
    const [personTypeContractor, setPersonTypeContractor] = useState(0)
    const [errorInEmail, setErrorInEmail] = useState(false)
    const [companySelectedDialog, setCompanySelectedDialog] = useState('')
    const [beforePage, setBeforePage] = useState('')

    let titleDialogCreate = (paramsId === 2) ? `${t('contractorsCatalogView.dialog.create.new')} ${t('contractorsCatalogView-title-repse-detail')}` : `${t('contractorsCatalogView.dialog.create.new')} ${t('contractorsCatalogView-title-contractor')}`
    let emailLabelDialog = (paramsId === 2) ? `${t('contractorsCatalogView.dialog.create.email')} ${t('contractorsCatalogView-title-repse-detail')}` : `${t('contractorsCatalogView.dialog.create.email')} ${t('contractorsCatalogView-title-contractor')}`
    let is1600 = useMediaQuery('(max-width: 1600px)')
    let is1366 = useMediaQuery('(max-width: 1366px)')
    let is1200 = useMediaQuery('(max-width: 1200px)')
    let is820 = useMediaQuery('(max-width: 820px)')
    let is560 = useMediaQuery('(max-width: 560px)')

    useEffect(() => {
        if (headerTitleinDetail.clicked) {
            setHeaderTitle()
        }

        setHeaderTitle()
        setPersonTypeContractor(props.initialPerson)
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [nameComponentUser, headerTitleinDetail, paramsId])

    useEffect(() => {
        if (!contractors) return
        setDataContractors(contractors)
    }, [contractors])

    useEffect(() => {
        if (!companies) return
        setCompaniesFilter(companies)
    }, [companies])

    useEffect(() => {
        let contractorsFilter = []
        let copyContractors = [...contractors]
        if (companyFilerSelected !== '0' && companyFilerSelected !== 0) {
            copyContractors.map((contractor) => {
                let company = contractor.company.find((company) => company.id === companyFilerSelected)
                if (company) {
                    contractorsFilter.push(contractor)
                }
                return company
            })
        } else {
            contractorsFilter = copyContractors
        }

        let newContractorsFilter = [...new Map(contractorsFilter.map(item => [item['id'], item])).values()]

        let newData = newContractorsFilter.filter((contractor) =>
            (contractor.name.toLowerCase().includes(contractorNameSearch.toLowerCase()) || contractor.name.includes(contractorNameSearch.toLowerCase())) &&
            ((contractorsStatusSelected === 0) ? contractor.status === true || contractor.status === false : contractor.status === contractorsStatusSelected)
        )
        setDataContractors(newData)
    }, [contractorNameSearch, contractorsStatusSelected, companyFilerSelected])


    useEffect(() => {
        if (!contractorGridSelected || !contractorGridSelected.id) return
        setImagetitle(contractorGridSelected.logo)
    }, [contractorGridSelected])

    useEffect(() => {
        if (!companiesToClassified || companiesToClassified.length === 0) return
        setCompanySelectedDialog(companiesToClassified[0].id)
    }, [companiesToClassified])

    const setHeaderTitle = () => {
        const name = headerTitleinDetail.name || nameComponentUser
        if (name === '' && paramsId === 1) {
            setTitleHeader(t('contractorsCatalogView-contractor-title'))
        }

        if (name === '' && paramsId === 2) {
            setTitleHeader(t('contractorsCatalogView-title-repse'))
        }

        if (name === t('contractorsCatalogView-btn-details') && paramsId === 1) {
            setTitleHeader(t('contractorsCatalogView-title-contractor'))
        }

        if (name === t('contractorsCatalogView-btn-details') && paramsId === 2) {
            setTitleHeader(t('contractorsCatalogView-title-repse-detail'))
        }

        if (name === t('contractorsCatalogView-btn-add-provider') && paramsId === 1) {
            setTitleHeader(t('contractorsCatalogView-btn-add-contractor'))
        }

        if (name === t('contractorsCatalogView-btn-add-provider') && paramsId === 2) {
            setTitleHeader(t('contractorsCatalogView-btn-add-provider'))
        }

        if (name === t('contractorsCatalogView-btn-sort')) {
            setTitleHeader(t('contractorsCatalogView-title-clasifiers'))
        }

        if (name === t('contractorsCatalogView-btn-disable')) {
            setTitleHeader(t('contractorsCatalogView-btn-disable'))
        }

        if (name === t('contractorsCatalogView-btn-additional-data')) {
            setTitleHeader(t('contractorsCatalogView-btn-additional-data'))
        }

        if (name === t('contractorsCatalogView-btn-disable') && paramsId === 1) {
            setTitleHeader(t('contractorsCatalogDisable-title-header-contractor'))
        }

        if (name === t('contractorsCatalogView-btn-disable') && paramsId === 2) {
            setTitleHeader(t('contractorsCatalogDisable-title-header-provider'))
        }
    }

    const backGridView = () => {
        setShowDetails(false)
        setNameComponentUser('')
        setHeaderTitleinDetail({ clicked: false, name: '' })
    }

    const handleAddProvider = () => {
        setShowCreateContractor(true)
    }

    const onChangeSearchProvider = (e) => {
        setContractorNameSearch(e.target.value)
    }

    const filterChangeContractors = (e) => {
        let valueStatusSelected
        if (e.target.value !== 0 && e.target.value !== '0') {
            valueStatusSelected = (e.target.value === 'true') ? true : false
        } else {
            valueStatusSelected = 0
        }
        setContractorsStatusSelected(valueStatusSelected)
    }

    const filterChangeCompanies = (e) => {
        let value = e.target.value
        setCompanyFilterSelected(value)
    }

    const toggleDialogIcon = () => {
        setShowDialogIcon(!showDialogIcon)
    }

    const sendOtherPage = (page, e) => {
        setBeforePage(nameComponentUser)
        setNameComponentUser(page)
        setShowDetails(true)
    }

    //Delete icon, cancel btn
    const onCancelIcon = () => {
        toggleDialogIcon()
        setImagetitle(null)
        setuploadImage(null)
    }

    //save icon
    const onSaveImg = (e) => {
        const fileObj = e.target.files && e.target.files[0]
        if (!fileObj) {
            return
        }
        let url = URL.createObjectURL(fileObj)
        let contractor = Object.assign({}, contractorGridSelected)
        contractor.logo = url

        setContractorGridSelected(contractor)
        setImagetitle(url)
        setLogoFile(fileObj)
    }


    const handleChangeContractrorEmail = (e) => {
        setNewContractorEmail(e.target.value)
    }

    const handleItselfRegister = (e) => {
        setItselfRegister(e.target.checked)
        if (e.target.checked) {
            setNewContractorEmail(selfEmail)
        } else {
            setNewContractorEmail('')
        }
    }


    const handleChangeLimitDate = (e) => {
        let todayDate = new Date()
        let eventDate = new Date(e.target.value)

        eventDate.setHours(0, 0, 0, 0)
        todayDate.setHours(0, 0, 0, 0)

        if (
            eventDate < todayDate ||
            eventDate > limitMaxDate ||
            eventDate === null
        ) {
            setToggleErrorInDate(true)
            setNewContractLimitDate(today)
        } else if (eventDate >= todayDate || eventDate <= limitMaxDate) {
            setToggleErrorInDate(false)
            setNewContractLimitDate(e.target.value)
        }
    }


    const handleChangeContractrorNotes = (e) => {
        setNewContractorNotes(e.target.value)
    }

    const createContractor = async () => {
        let classifierId = (paramsId === 2) ? 2 : 1
        let typePerson = (paramsId === 2) ? true : false
        let person = (paramsId === 2) ? t('contractorsCatalogView-title-repse-detail') : t('contractorsCatalogView-title-contractor')
        let errorMessage = `${t('contractorsCatalogView.error.create.contractor')} ${person}`
        let emailRegex =
            /^(([^<>()[\]\\.,:\s@\']+(\.[^<>()[\]\\.,:\s@\']+)*)|(\'.+\'))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/

        try {
            if (newContractorEmail.match(emailRegex)) {
                const body = {
                    email: newContractorEmail,
                    emailCreator: selfEmail,
                    name: newContractorName,
                    limitDate: newContractLimitDate,
                    notes: newContractorNotes,
                    isRepse: typePerson,
                    onlyCreateContractor: true,
                    classifierId: classifierId,
                    companyId: companySelectedDialog,
                    contractorPersonType: personTypeContractor
                }

                setShowCreateContractor(false)
                toggleLoadingRequesting(true)
                let response = await contractRequest.createContractor(body, token)
                if (response.data.statusCode === 200) {
                    toggleLoadingRequesting(false)
                    toggleCompletedRequesting(true, 4000, false)
                } else if (response.data.statusCode === -2) {
                    errorMessage = t('dialogContractor.error.email.exist')
                    toggleLoadingRequesting(false)
                    toggleErrorRequesting(true, errorMessage, 4000, false)
                } else {
                    toggleLoadingRequesting(false)
                    toggleErrorRequesting(true, errorMessage, 4000, false)
                }
            } else {
                setErrorInEmail(true)
                setTimeout(() => {
                    setErrorInEmail(false)
                }, 3000)
            }
        } catch (e) {
            toggleLoadingRequesting(false)
            toggleErrorRequesting(true, errorMessage, 4000, false)
        }
    }

    const filterChangeCompaniesDialog = (e) => {
        let value = e.target.value
        setCompanySelectedDialog(value)
    }

    return (
        <div className='standard-wrapper'>
            {
                isLoadingView ? (
                    <SimpleLoading />
                ) : (
                    <Container
                        xs={12}
                        lg={12}
                        md={12}
                        sm={12}
                        spacing={4}
                        className='contractorsCatalogView-container'
                    >
                        {showLoadingRequesting ? (<DialogSystemGLPure toggleLoadingRequesting={toggleLoadingRequesting} showLoadingRequesting={showLoadingRequesting} />) : null}
                        {showCompletedRequesting ? (<DialogSystemGLPure showCompletedRequesting={showCompletedRequesting} toggleCompletedRequesting={toggleCompletedRequesting} />) : null}
                        {showErrorRequesting ? (<DialogSystemGLPure toggleErrorRequesting={toggleErrorRequesting} message={messageError} showErrorRequesting={showErrorRequesting} />) : null}
                        <Grid
                            item
                            lg={12}
                            md={12}
                            xs={12}
                            sm={12}
                            className='contractorsCatalogView-header'
                        >
                            <SubtitlePageHLPure
                                profileImg={imageTitle ? imageTitle : profileIconDefault}
                                imgProfile={profileIconDefault}
                                subtitle={titleHeader}
                                tooltipShow={(nameComponentUser === '') ? false : true}
                                titleTooltip={''}
                                descriptionTooltip={''}
                                uploadFile={toggleDialogIcon}
                                informationIcon={false}
                                altCustomImg={'info img'}
                                justShowImg={(nameComponentUser === t('contractorsCatalogView-btn-details')) ? false : true}
                                changeImgFile={(event) => onSaveImg(event)}
                                typeBox={true}
                                imageFromPc
                            />
                        </Grid>
                        <Grid
                            container
                            className='contractorsCatalogView-body'
                            xs={12}
                            lg={12}
                            md={12}
                            sm={12}
                            es={12}
                        >
                            {showDetails && nameComponentUser ?
                                (
                                    <ContractorsCatalogConfigurationView
                                        {...props}
                                        dataContractors={dataContractors}
                                        setDataContractors={setDataContractors}
                                        nameComponentUser={nameComponentUser}
                                        hideShowDetails={backGridView}
                                        token={token}
                                        user={user}
                                        setHeaderTitleinDetail={setHeaderTitleinDetail}
                                        setNameComponentUser={setNameComponentUser}
                                        setShowDetails={setShowDetails}
                                        toggleErrorRequesting={toggleErrorRequesting}
                                        toggleLoadingRequesting={toggleLoadingRequesting}
                                        toggleCompletedRequesting={toggleCompletedRequesting}
                                        showCompletedRequesting={showCompletedRequesting}
                                        showErrorRequesting={showErrorRequesting}
                                        showLoadingRequesting={showLoadingRequesting}
                                        stateNameComponentUser={stateNameComponentUser}
                                        setStateNameComponentUser={setStateNameComponentUser}
                                        isLoadingView={isLoadingView}
                                        sendOtherPage={sendOtherPage}
                                        backGridView={backGridView}
                                        contractorGridSelected={contractorGridSelected}
                                        toggleLoadingScreen={toggleLoadingScreen}
                                        getConractorsForService={getConractorsForService}
                                        setImagetitle={setImagetitle}
                                        beforePage={beforePage}
                                    />
                                ) : (
                                    <>
                                        <Grid
                                            item
                                            lg={12}
                                            md={12}
                                            sm={12}
                                            xs={12}
                                            className='contractorsCatalogView-navbar'
                                        >
                                            <div className='contractorsCatalogView-navbar-container-btns'>
                                                <div className='contractorsCatalogView-btn-add'>
                                                    <ButtonAddHLPure
                                                        nameBtn={titleBtnAdd}
                                                        iconAdd
                                                        onClickBtn={handleAddProvider}
                                                    />
                                                </div>
                                                <div className='contractorsCatalogView-btn-search-provider'>
                                                    <SearchBarHLPure
                                                        placeholder={placeHolderSearch}
                                                        onSearchChange={(e) => onChangeSearchProvider(e)}
                                                        searchValue={contractorNameSearch}
                                                    />
                                                </div>
                                                <div className='contractorsCatalogView-btn-filer-status'>
                                                    <FilterHLPure
                                                        options={contratorsStatusFilter}
                                                        nameOption='name'
                                                        valueItem='id'
                                                        optionsValue={contractorsStatusSelected}
                                                        onFilterChange={(e) => filterChangeContractors(e)}
                                                    />
                                                </div>
                                            </div>
                                            <div className='contractorsCatalogView-navbar-container-company'>
                                                <DropDownBtnHLPure
                                                    labelDropDown={t('contractorsCatalogView.dropdwown.company')}
                                                    optionsDropDown={companiesFilter}
                                                    onDropDownChange={(e) => filterChangeCompanies(e)}
                                                    optionsValue={companyFilerSelected}
                                                    valueItem={'id'}
                                                    nameOption={'name'}
                                                    flex={(is560) ? false : true}
                                                />
                                            </div>
                                        </Grid>
                                        <Grid
                                            item
                                            className='contractorsCatalogView-gridContainer'
                                        >
                                            <GridSelectionHLPure
                                                styleGeneral={true}
                                                styleGeneralClass={'contractorsCatalogView-general-grid'}
                                                pageable={true}
                                                skip={0}
                                                take={6}
                                                dataGrid={dataContractors}
                                                filter={true}
                                                onFilterChange={filterChangeContractors}
                                                onSelectedItem={setContractorGridSelected}
                                                setShowDetails={setShowDetails}
                                                setNameComponentUser={setNameComponentUser}
                                                columnOne={(!is820) ? true : false}
                                                columnTwo={true}
                                                columnThree={(!is1200) ? true : false}
                                                columnFive={true}
                                                titleRow1={t('contractRepseView.column.1')}
                                                titleRow2={titleColumnName}
                                                titleRow3={t('contractorsCatalogView.title.three.grid')}
                                                titleRow5={t('contractRepseView.column.2')}
                                                headerColumnOne={headerColumnOne}
                                                cellColumnOne={cellColumnOne}
                                                headerColumnTwo={headerColumnTwo}
                                                cellColumnTwo={cellColumnTwo}
                                                headerColumnThree={headerColumnThree}
                                                cellColumnThree={cellColumnThree}
                                                iconOneActive={(!is820) ? true : false}
                                                iconTwoActive={(!is820) ? true : false}
                                                iconThirdActive={(!is820) ? true : false}
                                                iconFourthActive
                                                labelOneActions={t('contractorsCatalogView-btn-disable')}
                                                labelTwoActions={t('contractorsCatalogView.watch.document')}
                                                labelThirdActions={t('contractorsCatalogView-btn-sort')}
                                                labelFourthActions={t('contractorsCatalogView-btn-details')}
                                                // styleGrid={{ maxHeight: '400px' }}
                                                mobileFunction={false}
                                            />
                                        </Grid>
                                    </>
                                )
                            }
                            {
                                showCreateContractor ? (
                                    <DialogContractor
                                        //Nombre
                                        labelNameInput={t('contractorsCatalogView.dialog.create.name')}
                                        stateNameContractor={newContractorName}
                                        onChangeNameContractor={(e) => setNewContractorName(e.target.value)}
                                        //Correo
                                        labelEmailInput={emailLabelDialog}
                                        stateEmailContractor={newContractorEmail}
                                        onChangeEmailContractor={handleChangeContractrorEmail}
                                        myselfRegisterState={itselfRegister}
                                        onChangeMyselfRegister={(e) => handleItselfRegister(e)}
                                        //Fecha
                                        labelDataPicker={t('contractorsCatalogView.dialog.create.date.limit')}
                                        stateDate={newContractLimitDate}
                                        limitDate={today}
                                        limitMaxDate={limitMaxDate}
                                        onChangeDateContractor={handleChangeLimitDate}
                                        onErrorDateState={toggleErrorInDate}
                                        //Notas
                                        stateNotesContractor={newContractorNotes}
                                        onChangeNotesContractor={handleChangeContractrorNotes}
                                        //Botones y Dialog
                                        cancelName={t('button.cancel')}
                                        submitName={t('button.save')}
                                        titleDialog={titleDialogCreate}
                                        cancel={() => setShowCreateContractor(false)}
                                        handleSubmit={() => createContractor()}
                                        //Dropdown
                                        personTypeLabel={t('contractingRegistrationDataView.dropdown.label.type.person')}
                                        onTypePersonChange={(e) => setPersonTypeContractor(Number(e.target.value))}
                                        contractorsTypeOptions={contractorsTypes}
                                        valueOptionDropdown={'id'}
                                        nameOptionDropdown={'value'}
                                        companies={companiesToClassified}
                                        filterChangeCompanies={filterChangeCompaniesDialog}
                                        companyFilerSelected={companySelectedDialog}
                                        showCompanyDrop={true}
                                    />
                                ) : null
                            }
                        </Grid>
                        {!nameComponentUser &&
                            <Grid
                                container
                                className='contractorsCatalogView-container-btns'
                            >
                                <ButtonHLPure
                                    nameBtn={t('button.return')}
                                    onClickBtn={() => props.history.push('/help-desk')}
                                />
                            </Grid>
                        }
                        <Grid item xs={12} lg={12} md={12} sm={12}>
                            <PromotionalFooterPure />
                        </Grid>
                    </Container>
                )
            }
        </div>
    )
}

export default ContractorsCatalogView